import IntlFormatExposer from './IntlExposer';

export { getIntl } from './IntlExposer';
export default IntlFormatExposer;
